export const salutation = [
    {
        value: "Dr.",
    },
    {
        value: "Mr.",
    },
    {
        value: "Mr. & Mrs.",
    },
    {
        value: "Mrs.",
    },
    {
        value: "M.s",
    },
];

export const numberType = [
    {
        value: "Fax",
    },
    {
        value: "Home",
    },
    {
        value: "Mobile",
    },
    {
        value: "Office",
    },
];

export const tenantStatus = [
    {
        value: "Financialy Responsible"
    },
    {
        value: "Other Occupant"
    },
    {
        value: "Co-signer"
    }
];

export const moveIns = [
    {
        value: "Upon move-in",
    },
    {
        value: "1 Day after move-in",
    },
    {
        value: "1 Week after move-in",
    },
    {
        value: "2 Weeks after move-in",
    },
    {
        value: "3 Weeks after move-in",
    },
    {
        value: "4 Weeks after move-in",
    },
    {
        value: "5 Weeks after move-in",
    },
];

export const lateFeeType = [
    {
        value: "Flat"
    },
    {
        value: "Percent"
    },
];

export const gracePeriodType = [
    {
        value: "After number of days"
    },
    {
        value: "Fixed day of following month"
    },
];

export const filterType = [
    {
        value: "Every charge"
    },
    {
        value: "All recurring charges"
    },
    {
        value: "recurring_rent_only"
    },
];

export const activityStatus = [
    { value: "Pending"},
    { value: "Queued"},
    { value: "In Progress"},
    { value: "Complated"},
];

export const years = [
    {
        value: 2009,
    },
    {
        value: 2010,
    },
    {
        value: 2011,
    },
    {
        value: 2012,
    },
    {
        value: 2013,
    }

];

export const data = [
    {
        startDate: "",
        endDate: "",
        description: "",
        nextCharge: "",
        glAccount: "",
        amount: ""
    }
]

export const preference = [
    {
        value: "Paper & Electronic"
    },
    {
        value: "Paper"
    },
    {
        value: "Electronic"
    },
];

export const checks = [
    {
        value: "Print 1 check for each bill"
    },
    {
        value: "10 bills per check"
    },
    {
        value: "All bills on single check"
    },
];


export const none = [
    {
        value: ""
    }
];